module.exports = __webpack_public_path__ + "img/golf-ball-tee.917fcd86.svg";